export enum BendingOption {
    Normal,
    Difference,
}
